// extracted by mini-css-extract-plugin
module.exports = {"noScrolling":"page_noScrolling__BlbpP","note":"page_note__N2CEK","note_content":"page_note_content__EN5eq","last_updated":"page_last_updated__iqSPt"};